
import { Component, Emit, Vue, Prop } from 'vue-property-decorator'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { formatDate } from '@/utils/date'

@Component({
    components: {
        FontAwesomeIcon,
    },
})
export default class HomeAppItemBrand extends Vue {
    @Prop() private app!: AppEntity

    get brandUrl(): string {
        return `https://deliverydireto.com.br/admin/${this.app.brand.encodedName}`
    }

    get brandCreated(): string {
        return formatDate(this.app.brand.created || '')
    }

    public onClickStopPropagation(e: Event) {
        e.stopPropagation()
    }
}
